import React, { useEffect, useState } from 'react'
import module from './index.module.css'
import { Button, CircularProgress } from '@mui/material';
import { startEKyc } from '../../../../../util/eKyc';
import { Link } from 'react-router-dom';


const StartEKyc = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(true);

    const handleInit = async () => {
        try {
            setIsLoaded(true);
            setError(false);
            await startEKyc();
            setIsLoaded(false);
        } catch (e) {
            console.log(e);
            setError(e);
            setIsLoaded(false);
        }
    };

    useEffect(() => {
        handleInit();
    }, []);

    return (
        <div>
            <div className={module.top}>
                <h1 className={module.title}>しばらくお待ちください</h1>
            </div>
            <div className={module.contents}>
                {isLoaded && (<CircularProgress color="success" />)}
                {error && (<div>
                    <p>エラーが発生しました</p>
                    <p>{error.message}</p>
                    <p>{error.stack}</p>
                    <p>下記からお問い合わせください</p>
                    <p>
                        <Button
                            variant="outlined"
                            sx={{ padding: "2px 8px", marginLeft: "8px" }}
                            LinkComponent={Link}
                            to="/contact"
                        >
                            お問い合わせ
                        </Button>
                    </p>
                </div>)}
            </div>
        </div>
    )
}

export default StartEKyc